
const getPatient = state => state.patient
const getAttachment = state => state.attachment

export default {
  getPatient,
  getAttachment
}



// WEBPACK FOOTER //
// ./src/store/modules/patient/getters.js